import { useEffect, useState } from "react";
import { get, useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { getQueryParam } from "@circle-react/helpers/urlHelpers";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { CouponBadge } from "./CouponBadge";
import { CouponField } from "./CouponField";

interface CouponFormProp {
  className?: string;
}

export const CouponForm = ({ className }: CouponFormProp) => {
  const {
    watch,
    clearErrors,
    formState: { errors: formErrors },
  } = useFormContext();
  const { areCouponsEnabled, applyCouponCode, clearCouponCode } =
    usePaywallCheckoutContext();
  const [isInitialCouponApplied, setInitialCouponApplied] = useState(false);
  const [isAddCouponClicked, setAddCouponClickedState] = useState(false);
  const { coupon_code_applied } = watch();
  const { previewMutation } = usePaywallCheckoutContext();

  const onClick = () => {
    const error = get(formErrors, "coupon_code");

    if (isAddCouponClicked) {
      clearCouponCode({ resetPreview: !!error });
      clearErrors("coupon_code");
    }

    setAddCouponClickedState(!isAddCouponClicked);
  };

  useEffect(() => {
    const couponCode = getQueryParam("coupon_code");

    if (couponCode && !isInitialCouponApplied && previewMutation.isSuccess) {
      setInitialCouponApplied(true);
      setAddCouponClickedState(true);
      applyCouponCode(couponCode);
    }
  }, [applyCouponCode, isInitialCouponApplied, previewMutation.isSuccess]);

  if (!areCouponsEnabled) {
    return null;
  }

  if (coupon_code_applied) {
    return <CouponBadge setAddCouponClickedState={setAddCouponClickedState} />;
  }

  return (
    <div className={classNames("flex w-full flex-col gap-y-2", className)}>
      <Button
        variant="link"
        small
        className="!p-0 text-left !no-underline"
        type="button"
        onClick={onClick}
      >
        {isAddCouponClicked ? (
          <Icon type="20-minus" className="!w-4" />
        ) : (
          <Icon type="20-plus-v3" className="!w-4" />
        )}
        <Typography.LabelXs color="text-secondary" weight="medium">
          <span className="cursor-pointer">{t("coupon_code")}</span>
        </Typography.LabelXs>
      </Button>
      {isAddCouponClicked && <CouponField />}
    </div>
  );
};
